module.exports = __webpack_public_path__ + "static/media/arrowLeft.7b468b09.webp";